import billings from '../constants/billings';
import { setEcwidAppID } from '../constants/ecwidAppID';

/**
 * Initialize ecwid app id based on billing method
 *
 * @function
 * @param billing - external or internal app billing
 */

function initEcwidAppID(billing, environment) {
  const developExtAppID = 'developExtAppID';
  const developIntAppID = 'developIntAppID';
  const productionExtAppID = 'product-bundles';
  const productionIntAppID = 'product-bundles-app';
  switch (billing) {
    case billings.ext:
      if (environment === 'production') {
        setEcwidAppID(productionExtAppID);
      } else if (environment === 'develop') {
        setEcwidAppID(developExtAppID);
      }
      break;
    case billings.int:
      if (environment === 'production') {
        setEcwidAppID(productionIntAppID);
      } else if (environment === 'develop') {
        setEcwidAppID(developIntAppID);
      }
      break;
    // no default
  }
}

export default initEcwidAppID;
